import { useLoadingStore } from "@/store/index";

// Nuxt client plugin to drive the header navigation loading bar via Pinia store.
export default defineNuxtPlugin((nuxtApp) => {
  const loadingStore = useLoadingStore();

  const stopLoading = () => loadingStore.setNavLoading(false);

  nuxtApp.hook("page:start", () => {
    loadingStore.setNavLoading(true);
  });

  nuxtApp.hook("page:finish", stopLoading);
  nuxtApp.hook("app:error", stopLoading);
});
